<template>
  <div class="pb-5 pt-2 flex bg-white w-full fixHeight">
    <div :class="this.containerSplit === true ? 'w-1/2 pl-4 border-r-2 border-solid border-gray-400 overflow-y-auto' : 'w-11/12 mx-5 overflow-y-auto'">
      <div class="pr-4">
        <template>
          <div class="not-italic font-normal text-zt-xl leading-8 flex items-center text-zt-primary-200">
            {{$t("message.FileUploadComponent.title_img")}}
          </div>
        </template>
        <template>
          <div class="mt-4 flex">
            <div class="w-9/12">
              <v-text-field
                flat
                label
                prepend-inner-icon="search"
                v-model="search"
                clearable
                @click:clear="clearSearch"
                :class="this.containerSplit === true ? 'w-1/2' : 'w-1/4'"
								data-vs-textfield="search"
              ></v-text-field>
            </div>
            <div class="w-3/12 my-auto">
              <p class="float-right">{{$t("message.FileUploadComponent.total")}}: {{ this.filteredItems.length }}</p>
            </div>
          </div>
          <!-- Lista -->
          <div class="main--container mt-4 shadow w-full bg-white">
            <vue-loading
                v-if="loading"
                background-color="rgba(0,0,0,0.0)"
                :active="loading"
                color="#4F41A3"
                :width="60"
								:height="60"
								:is-full-page="false"
            />
            <template v-if="filteredItems.length > 0">
              <zt-list-item
                v-model="docTypeSelected"
                v-for="documentType in filteredItems"
                :class="docTypeSelected != null && docTypeSelected.id === documentType.id ? 'mt-2 ml-2 list-hover bg-zt-dark-100' : 'mt-2 list-hover'"
                :color="docTypeSelected != null && docTypeSelected.id === documentType.id ? 'zt-primary-200' : ''"
                :key="documentType.id"
                :title="documentType.nombre"
                @click="selectDocumentType(documentType)"
              >
                <template slot="icon">
                  <zt-icon name="file" :class="docTypeSelected != null && docTypeSelected.id === documentType.id ? 'custom-file-icon text-purple-600' : 'custom-file-icon'" />
                </template>
              </zt-list-item>
            </template>
            <template v-if="filteredItems.length === 0 && loading === false">
              <div class="flex flex-col justify-center items-center pb-12 pt-4">
                <div class="h-40">
                  <graphic-base height="100%" width="100%" :viewBox="'0 0 160 120'">
                    <EmptyStateSVG />
                  </graphic-base>
                </div>
                <p class="text-zt-primary-200 text-base leading-5 pt-2 font-normal">{{$t("message.FileUploadComponent.emptyState")}}</p>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
    <div v-if="this.containerSplit === true" class="w-4/5 pr-4 flex-1 flex overflow-hidden">
      <div class="pl-4 flex-1 overflow-y-auto">
        <template>
          <dwt-form-generator-desktop
            @checkLoadAprove="checkLoadAprove=$event"
            @rollbackSelectedDoc="docTypeSelected=$event"
            @nullDocMetadata="documentMetadata=$event"
            @updateKey="componentKey += $event"
            @updateContainerSplit="containerSplit=false"
            :key="componentKey"
            :metadata="documentMetadata"
            :imageText="$t('message.FileUploadComponent.formComponent.selectFileImage')"
            :pdfText="$t('message.FileUploadComponent.formComponent.selectFilePdf')"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import UploadFiles from '@/apiClient/UploadFiles'
import DwtFormGeneratorDesktop from '@/components/generics/DWTFormGeneratorDesktop'
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import EmptyStateSVG from '@/components/commons/Illustrations/graphicSVG/graphicEmptyState'

export default {
  components: {
    DwtFormGeneratorDesktop,
    graphicBase,
    EmptyStateSVG
  },
  data() {
    return {
      headerView: 5,
      loading: false,
      docTypeSelected: {},
      documentTypes: [],
      documentMetadata: null,
      documentFiles: {},
      componentKey: 0,
      checkLoadAprove: false,
      documentsTotal: 0,
      search: '',
      containerSplit: false
    }
  },

  async created() {
    this.uploadFiles = new UploadFiles()
    this.getDocumentTypes()
  },
  update() {},
  watch: {
    checkLoadAprove: function() {
      if (this.checkLoadAprove === true) {
        this.getDocumentTypes()
      }
    }
  },
  computed: {
    filteredItems() {
      return _.orderBy(
        this.documentTypes.filter(documentType => {
          if (!this.search) {
            return this.documentTypes
          } else {
            return documentType.nombre
              .toLowerCase()
              .includes(this.search.toLowerCase())
          }
        }),
        'nombre'
      )
    }
  },
  methods: {
    clearSearch() {
      this.search = ''
    },
    getDocumentTypes() {
      this.loading = true;
      this.uploadFiles
        .getDocumentTypesList()
        .then(response => {
          this.loading = false;
          this.documentTypes = response.data.results.data
          this.documentsTotal = this.documentTypes.length
          this.checkLoadAprove = false
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            type: 'error',
            title: this.$t(
              `message.errorReference.${error.response.data.code}`
            ),
            showConfirmButton: true,
            confirmButtonText: this.$t(
              'message.FileUploadComponent.swal.accept'
            )
          })
        })
    },
    selectDocumentType(value) {
      this.containerSplit = true
      this.documentMetadata = value
      this.docTypeSelected = value
      this.forceRerender()
    },
    forceRerender() {
      this.componentKey += 1
    }
  }
}
</script>

<style lang="scss">
@import '../../../../public/assets/scss/_config.scss';

.caw-sichern .container {
	width: 100%;
	margin-top: 1em;
}

.caw-sichern .backgroundSelect {
	padding-left: 1em;
	padding-right: 1em;
	margin-top: -10px;
	-webkit-box-shadow: 0px -4px 30px -12px rgba(0, 0, 0, 0.86);
	-moz-box-shadow: 0px -4px 30px -12px rgba(0, 0, 0, 0.86);
	box-shadow: 0px -4px 30px -12px rgba(0, 0, 0, 0.86);
}

.caw-sichern .center {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 8em 0px;
}

.index_img {
	background-image: url(../../../../public/assets/media/tasks/uploadFile.svg);
	margin: 0 auto;
	background-size: contain;
	width: 40%;
	height: 21vh;
}

.index_text_title {
	margin: auto;
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 23px;
	color: #2470a0;
}

.index_text_subtitle {
	margin: auto;

	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	color: #969696;
}

//stepper
.caw-sichern .container-step {
	max-width: 100%;
	margin: 0 auto;
}

.caw-sichern .step-indicator {
	margin-top: 50px;
	display: flex;
	align-items: center;
	//padding: 0 40px;
}

.caw-sichern .step {
	display: flex;
	align-items: center;
	flex-direction: column;
	position: relative;
	z-index: 1;
}

.caw-sichern .step-indicator .step-icon {
	height: 13px;
	width: 13px;
	border-radius: 50%;
	background: #c2c2c2;
	text-align: center;
	color: #ffffff;
	position: relative;
	line-height: 50px;
	font-size: 20px;
}

.caw-sichern .step.active .step-icon {
	background: #54caa6;
}

.caw-sichern .indicator-line {
	width: 100%;
	height: 2px;
	background: #c2c2c2;
	flex: 1;
}

.caw-sichern .indicator-line.active {
	background: #54caa6;
}

.caw-sichern .stepper-text {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: -35px;
}

.caw-sichern .step-text {
	width: 20%;
	color: #2470a0;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 16px;
}

.caw-sichern #step3 {
	padding-left: 18px;
}

@media screen and (max-width: 500px) {
	.caw-sichern .step p {
		font-size: 11px;
		bottom: -20px;
	}
}

.caw-sichern .pillFiltersInDocument {
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
	text-align: center;
	color: $bluePrimary;
	border: 1px solid $bluePrimary;
	box-sizing: border-box;
	border-radius: 30px;
	padding: 0.9em;
	margin-right: 0.5em;
	background: $white;
	display: inline-block;
	margin-bottom: 0.5em;
}

.caw-sichern .cardTextMarginFilterDates {
	display: flex;
	justify-content: center;
}

.caw-sichern .icon-Close:before {
	color: $bluePrimary;
	font-weight: 700;
	font-size: 0.9em;
}

.caw-sichern .imageContainer {
	width: 96%;
	height: 96%;
	max-width: 800px;
	max-height: 600px;
	position: absolute;
	overflow: hidden;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	margin: auto;
	background: #2b2b2c;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.caw-sichern .imageContainer > img {
	display: block;
	max-width: 100%;
	max-height: 100%;
	cursor: move;
	touch-action: none;
}

.caw-sichern .carga-archivos-container {
	margin-left: 1.5em;
	margin-top: 1em;
	margin-bottom: 1em;
}

.caw-sichern .carga-archivos-link {
	text-decoration: none;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 20px;
	color: #54caa6;
}

.caw-sichern .vListClass {
	background-color: $background !important ;
	padding-top: 8px !important;
}

.caw-sichern .documentSignatureTop {
	font-style: normal;
	font-weight: 500;
	font-size: 1.7em;
	line-height: normal;
	color: $bluePrimary;
	margin: 7px 16px 16px 16px;
	// margin-top: 5em;
}

.caw-sichern .documentSignature {
	font-style: normal;
	font-weight: 500;
	font-size: 1.7em;
	line-height: normal;
	color: $bluePrimary;
	margin: 16px;
	// margin-top: 5em;
}

.caw-sichern .noDocumentsNoSign {
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	text-align: center;
	color: $textSecondary;
}

.caw-sichern .icon-doc-consultRRHH:before {
	font-size: 1.5em;
	color: $error;
	content: '\e972';
}

.caw-sichern .icon-Doc-noSignature:before {
	margin-right: 0.37em;
	font-size: 1.5em;
	color: $error;
	content: '\e919';
}

.caw-sichern .icon-Doc-noSignatureDisable:before {
	margin-right: 0.37em;
	font-size: 1.5em;
	color: $grayFont;
	content: '\e919';
}

.caw-sichern .icon-Doc-noSignatureEform:before {
	font-size: 1.5em;
	color: $error;
	content: '\e929';
}

.caw-sichern .icon-Doc-noSignatureEformDisable:before {
	font-size: 1.5em;
	color: $grayFont;
	content: '\e929';
}

.caw-sichern .icon-Doc-Signature:before {
	margin-right: 0.37em;
	font-size: 1.5em;
	// color: $buttonPrimary;
	color: #969696;
	content: '\e919';
}

.caw-sichern .icon-Doc-dissatisfiedSignature:before {
	margin-right: 0.37em;
	font-size: 1.5em;
	color: $buttonPrimary;
	content: '\e919';
}

.caw-sichern .tileNoSignature {
	border-left: 6px solid $error;
	border-radius: 0.3em;
	margin-top: 0.5em;
	background: #ffffff;
}

.caw-sichern .tileNoSignatureDisable {
	border: 1px solid #eeeeee;
	border-left: 6px solid $grayFont;
	border-radius: 0.3em 0 0 0.3em;
	margin-top: 5px;
	background: #ffffff;
}

.caw-sichern .tileSignature {
	border-left: 6px solid $buttonPrimary;
	border-radius: 0.3em;
	margin-top: 0.5em;
	background: #ffffff;
}

.caw-sichern .tileDissatisfiedSignature {
	border-left: 6px solid $buttonPrimary;
	border-radius: 0.3em;
	margin-top: 0.5em;
	background: #ffffff;
}

.caw-sichern .documentTitle {
	color: $bluePrimary;

	font-style: normal;
	font-weight: 500;
	font-size: 0.95em;
	line-height: 24px;
	width: 90%;
}

.caw-sichern .documentTitleDisable {
	color: $textSecondary;
	font-style: normal;
	font-weight: 500;
	font-size: 0.95em;
	line-height: 24px;
	width: 90%;
}

.caw-sichern .v-list__tile {
	padding: 0 !important;
}

.caw-sichern .documentSubtitle {
	font-style: normal;
	font-weight: normal;
	font-size: 0.8em;
	line-height: 16px;
	width: 90%;
	color: $textPrimary;
}

.caw-sichern .documentSubtitleDisable {
	font-style: normal;
	font-weight: normal;
	font-size: 0.8em;
	line-height: 16px;
	color: $textSecondary;
}

.caw-sichern .NoSignatureAdvice {
	font-style: normal;
	font-weight: normal;
	font-size: 0.75em;
	line-height: 16px;
	text-align: center;
	color: $white;
	padding-top: 3.5px;
	// margin-left: 10%;
	width: 83px;
	height: 22px;
	//background
	background: $error;
	border-radius: 23px;
}

.caw-sichern .NoSignatureAdviceDisable {
	font-style: normal;
	font-weight: normal;
	font-size: 0.75em;
	line-height: 16px;
	text-align: center;
	color: $white;
	padding-top: 3.5px;
	// margin-left: 10%;
	width: 83px;
	height: 22px;
	//background
	background: $grayFont;
	border-radius: 23px;
}

.caw-sichern .dissatisfiedSignatureDocument {
	font-style: normal;
	font-weight: normal;
	font-size: 0.75em;
	line-height: 16px;
	text-align: center;
	color: $textSecondary;
	padding-top: 3.5px;
	width: 130px;
	height: 22px;
}

.caw-sichern .tileContent {
	width: 55%;
}

//filtros

.caw-sichern .noDocumentTypesClass {
	margin-top: 0.3em;
	margin-bottom: 1em;
	line-height: 2.9em;
	color: $textSecondary;
}

.caw-sichern .boxModelSearchProperties {
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
	text-align: center;
	color: $bluePrimary;
	border: 1px solid $bluePrimary;
	box-sizing: border-box;
	border-radius: 30px;
	padding: 0.7em;
	margin-right: 0.5em;
	display: inline-block;
	// margin-bottom: 0.1em;
}

.caw-sichern .boxModelSearchPropertiesEnabled {
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
	text-align: center;
	color: $white;
	background-color: $bluePrimary;
	border: 1px solid $bluePrimary;
	box-sizing: border-box;
	border-radius: 30px;
	display: inline-block;
	padding: 0.7em;
	margin-right: 0.5em;
}

.caw-sichern .filterTitles {
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 19px;
	color: $bluePrimary;
}

.caw-sichern .calendarFix {
	width: 50%;
	float: left;
}

.caw-sichern .buttonSaveFiltersProperties {
	width: 75%;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: normal;
	text-align: center;
	letter-spacing: 0.0357143em;
}

.caw-sichern .buttonClearFiltersProperties {
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
}

.caw-sichern .icon-Delete:before {
	color: $textSecondary;
	width: 70%;
	font-size: 0.8em;
}

.caw-sichern .containersWrap {
	height: 100vh;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	background-color: #e9e9e9;
}

.caw-sichern .titleContainer {
	position: fixed;
	text-align: left;
	width: 100%;
	border-bottom: 1px solid rgba(0, 0, 0, 0.12);
	height: 110px;
	background-color: white;
	z-index: 100000;
}

.caw-sichern .titleContainerSplited {
	position: fixed;
	text-align: left;
	width: 50%;
	border-bottom: 1px solid rgba(0, 0, 0, 0.12);
	height: 110px;
	background-color: white;
	z-index: 100000;
	top: 0;
}

.caw-sichern .titleContainerSplited .container,
.caw-sichern .titleContainer .container {
	padding-top: 50px;
	padding-bottom: 18px;
}

.caw-sichern .leftContainer {
	height: 100vh;
	width: 100%;
	display: flex;
	align-items: left;
	flex-direction: column;
	background-color: white;
}
.caw-sichern .leftContainerSplited {
	height: 100vh;
	width: 50%;
	display: flex;
	align-items: left;
	flex-direction: column;
	background-color: white;
	float: left;
}
.caw-sichern .rightContainer {
	display: none;
}
.caw-sichern .rightContainerSplited {
	height: 100vh;
	width: 50%;
	display: flex;
	align-items: right;
	flex-direction: column;
	// overflow-y: auto;
	background-color: white;
	border-left: 1px solid #c9c9c9;
	box-shadow: -5px 0 10px -5px rgba(0, 0, 0, 0.5);
	padding-top: 110px;
	float: right;
}
.caw-sichern .mx-3 {
	width: 40px;
	float: left;
}

.caw-sichern .v-input.mx-3.v-text-field {
	padding-top: 0px !important;
	margin-top: 0px !important;
	height: 35px !important;
	margin-left: 0px !important;
}

.caw-sichern .v-input__control:hover {
	cursor: pointer !important;
}

.caw-sichern .v-text-field > .v-input__control > .v-input__slot {
	background: transparent !important;
	border: 2px solid transparent !important;
	border-radius: 5px !important;
}

.caw-sichern .v-text-field > .v-input__control > .v-input__slot:hover {
	background: #eeeeee !important;
	border: 2px solid #eeeeee !important;
	border-radius: 5px !important;
}

.caw-sichern .v-text-field > .v-input__control > .v-input__slot:before {
	border-color: transparent !important;
}

.caw-sichern .v-text-field > .v-input__control > .v-input__slot:after {
	border-color: transparent !important;
}

.caw-sichern .v-text-field .v-input__prepend-inner {
	padding-right: 15px !important;
}

.caw-sichern .v-text-field .v-input__append-inner {
	padding-right: 15px !important;
}

.caw-sichern .mx-3.v-input--is-focused {
	width: 200px !important;
}

.caw-sichern .mx-3.v-input--is-focused .v-input__slot:before {
	border: 2px solid #eeeeee !important;
}

.caw-sichern .mx-3.v-input--is-focused .v-input__slot {
	background: transparent !important;
	border: 2px solid #eeeeee !important;
	border-radius: 5px !important;
}

.caw-sichern i.v-icon.material-icons.theme--light {
	margin-left: 15px !important;
}

.caw-sichern .openDocNoSignDocumetTitle {
	position: absolute;
	height: 24px;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 24px;
	display: flex;
	align-items: center;
	color: #6f6f6f;
}
.caw-sichern .tileNoSignatureDisable:hover .openDocSign {
	background: #eeeeee;
}
.caw-sichern .tileNoSignatureDisable:hover {
	border-left: 6px solid #2e6e9e;
}
.caw-sichern .tileNoSignatureDisable:hover .openDocNoSignDocumetTitle {
	color: #2e6e9e;
}

.caw-sichern .tileNoSignatureDisable:hover .icon-Doc-Signature:before {
	color: #2e6e9e;
}

.caw-sichern .title-container {
	border-bottom: 1px solid rgba(0, 0, 0, 0.12);
	max-width: unset;
}

.caw-sichern #document-list.fill-height {
	margin-top: 110px;
	overflow-y: auto;
}

.caw-sichern #document-list {
	padding-top: 0px;
}

.caw-sichern h1 {
	color: #4f4f4f;
}

.caw-sichern #totalContainer {
	float: right;
}
.caw-sichern #totalContainer p {
	text-align: right;
	margin-bottom: 0px;
	line-height: 35px;
}
.caw-sichern .v-list {
	height: 75vh !important;
	overflow-y: auto !important;
	clear: both;
}
.caw-sichern .mbcFixHeight {
	height: calc(100vh - 134px);
	overflow-y: auto;
}
.caw-sichern .theme--light.v-list {
	overflow-x: hidden;
}
.caw-sichern .swal2-container.swal2-shown {
	z-index: 100000 !important;
}

//new
.custom-file-icon {
	font-size: 2.5rem;
	align-self: center;
	color: #6f6f6f;
}
.titleFont {
	font-size: 24px;
}
.fixHeight {
	height: calc(100vh - 70px);
	overflow-y: hidden !important;
}
.list-hover:hover {
	background-color: #f5f5f5;
}
</style>